import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import logoImg from "@/assets/musikonzept-logo.png";

/** Weiterer Weg unter dem Hinweis, z. B. zum Musik-Kita-Paket statt zur Registrierung. */
export interface AktionBeendetZiel {
  text: string;
  pfad: string;
}

/**
 * Seite für eine beendete Aktion (Frage 257, Daniel 13.10.2026): Die Anmeldungen zur Didacta-Aktion
 * (`/didacta`, `/pitch2-geschenk`) liefen über `register-didacta-visitor`, die ohne Anmeldung Namen und Tarif
 * fremder Konten ändern konnte. Die Function ist stillgelegt (410), die Seiten zeigen nur noch diesen Hinweis
 * mit dem Weg zur normalen Registrierung. Der alte Stand steht in der Git-Historie.
 *
 * Seit der Sitzung „Aufräumen“ (14.10.2026, Fragen 288 und 292) zeigen auch `/kita-testzugang`, `/didacta-webinar`,
 * `/didacta-aktion` und `/comeback` diese Seite. Mit `ziel` steht statt „Kostenlos registrieren“ ein anderer Weg
 * vorn (beim Callcenter das Musik-Kita-Paket).
 */
export function AktionBeendet({ titel, text, ziel }: { titel: string; text: string; ziel?: AktionBeendetZiel }) {
  return (
    <>
      <Helmet>
        <title>{titel} – MusiKonzept</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
        <div className="w-full max-w-md space-y-6 rounded-2xl border border-border bg-card p-6 text-center shadow-lg md:p-8">
          <img src={logoImg} alt="MusiKonzept" className="mx-auto h-12 w-auto" />
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">Die Aktion ist beendet</h1>
            <p className="text-sm leading-6 text-muted-foreground">{text}</p>
          </div>
          <div className="flex flex-col gap-2.5">
            <Link
              to={ziel?.pfad ?? "/registrieren"}
              className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-[#227277] px-5 text-sm font-bold text-white hover:bg-[#1D2934]"
            >
              {ziel?.text ?? "Kostenlos registrieren"}
            </Link>
            <Link
              to="/login"
              className="inline-flex min-h-[44px] items-center justify-center rounded-full px-5 text-sm font-bold text-[#227277] hover:bg-muted"
            >
              Ich habe schon ein Konto
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
